import { Customer, VerifyRequestResponse } from '@ca/common/types'

export const CODE_LENGTH = 6

export interface VerifyContentProps {
  replace?: boolean
  onSuccess?: (data: Customer) => void
  customer?: Customer
  verifyRes: VerifyRequestResponse | null | undefined
}
